/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import Logger = alm.debug.Logger;

	export class Sentry {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			this.isInitialized = false;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public initialize():void {
			if (this.isInitialized) return;
			this.isInitialized = true;

			this.sentry = window['Sentry'];
			if (this.sentry) {

				let dsn = '';
				switch (location.hostname) {
					case '3dmap.yamap.com':
						dsn = 'https://88168e97b9334744a4aee1f951e27b34@sentry.io/1840775';
						break;
					case '3dmap-dev.yamap.com':
						dsn = 'https://9bbecfadf0994808a5effc94f70262ce@sentry.io/1842324';
						break;
				}

				if (dsn != '') {
					trace('[Sentry] Sentry init: dsn =\'' + dsn + '\'');
					this.sentry.init({ dsn: dsn });
				} else {
					trace('[Sentry] Sentry is not setup');
				}

			} else {
				Logger.error('[Sentry] Sentry is not loaded');
			}
		}

		public send(message:string, level:SentryLevel):void {
			trace('[Sentry] send : message =\'' + message + '\', level =', level);
			if (this.sentry) {
				this.sentry.captureMessage(message, level);
			}
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isInitialized:boolean;
		private sentry:any;

		public static getInstance():Sentry { return this.instance || (this.instance = new Sentry()) };
		private static instance:Sentry = null;
	}
}
